import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";
import { TGetPresignUrl } from "@/User/types/UserProfile";

export async function getUserPresignedUrl(locationId: string): Promise<TGetPresignUrl> {
	const query = gql`
		query getPresignUserImagePicture($locationId: String!) {
			getPresignUserImagePicture(locationId: $locationId) {
				presignedUrl
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getPresignUserImagePicture;
	} catch (err) {
		errorLogger(err as Error | string);
		return null;
	}
}
